<template>
  <div>
    <v-layout>
      <h5
        v-if="filteredTasks.length > 0"
        class="text-uppercase text-xs-left ml-2 mt-3"
      >
        Tarefas
      </h5>

      <v-btn
        v-if="filteredTasks.length == 0"
        color="#FFADDE"
        class="mt-3 create-task-btn"
        round
        depressed
        small
        @click="createTask = true"
      >
        <span
          class="text-capitalize px-2"
          style="color: primary"
        >Criar tarefa</span>
      </v-btn>
    </v-layout>
    <v-card v-if="filteredTasks.length > 0">
      <!-- <div class="pa-2 animated fadeIn delay-1s" v-if="filteredTasks.length == 0">
        Você não possui tarefas pendentes 😉
      </div>-->
      <v-list class="my-1">
        <virtualList
          :size="56"
          :remain="filteredTasks.length > 1 ? 2 : 1"
        >
          <template v-for="(task, i) in filteredTasks">
            <v-divider
              v-if="i !== 0"
              :key="`${i}-divider`"
            />

            <v-list-tile
              :key="`${i}-${task.description}`"
              :class="`mx-3 mb-1 mt-1 ${task.situacao}`"
            >
              <v-list-tile-content @click.stop="showDetails(task)">
                <v-list-tile-sub-title>
                  {{
                    task.description
                  }}
                </v-list-tile-sub-title>
                <v-list-tile-sub-title>
                  {{ task.due | formattedDate
                  }}<v-icon
                    class="ml-1"
                    small
                    :color="task.end ? '#95d097' : '#e0e0e0'"
                    @click.stop="updateStatus(task)"
                  >
                    check
                  </v-icon>
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </template>
        </virtualList>
      </v-list>

      <v-layout justify-end>
        <v-card-actions class="mx-0">
          <v-spacer />
          <v-btn
            color="primary"
            flat
            @click="createTask = true"
          >
            <span class="text-capitalize">criar tarefa</span>
          </v-btn>
          <v-btn
            color="primary"
            flat
            to="/tarefas"
          >
            <span class="text-capitalize">Exibir todas</span>
          </v-btn>
        </v-card-actions>
      </v-layout>

      <DetalhesTarefasModal v-model="taskDetails" />
    </v-card>

    <CadastrarTarefa
      v-model="createTask"
      :selected-person="person"
    />
  </div>
</template>

<script>
import virtualList from 'vue-virtual-scroll-list';
import { APIService } from '@/resources/campanha.js';
import { mapState, mapActions, mapGetters } from 'vuex';
import { EventBus } from '@/event-bus.js';
import format from 'date-fns/format';
import pt from 'date-fns/locale/pt';
import {
  distanceInWordsToNow,
  isFuture,
  isPast,
  endOfDay,
  addHours,
} from 'date-fns';

const api = new APIService();

export default {
  data: () => ({
    createTask: false,
    counterNewTask: 0,
    counterComplete: 0,
    newTask: {},
    taskDetails: false,
    menuPicker: false,
    time: null,
    teste: null,
    dtHoje: null,
  }),

  computed: {
    ...mapState(['tasks']),

    formattedCalendar() {
      return this.newTask.due ? format(this.newTask.due, 'DD/MM/YYYY') : '';
    },

    filteredTasks() {
      return this.$store.state.tasks.filter((el) => {
        if (!el.end && isFuture(endOfDay(addHours(el.due, 3)))) {
          el.situacao = 'EMDIA';
        }
        if (!el.end && isPast(endOfDay(addHours(el.due, 3)))) {
          el.situacao = 'ATRASADO';
        }
        if (el.end) el.situacao = 'CONCLUIDO';

        return el.person.id == this.person.id;
      });
    },
  },
  mounted() {},

  methods: {
    async showDetails(task) {
      await this.$store.commit('SET_SELECTEDTASK', task);
      await this.$store.dispatch('carregarContatoTask');
      this.taskDetails = true;
    },
    emitSnackBar() {
      const snackBar = {};
      snackBar.text = 'Tarefa agendada com sucesso!';
      snackBar.value = true;
      EventBus.$emit('activeSnackBar', snackBar);
    },
    async salvarTarefa() {
      this.counterNewTask += 1;

      this.$ga.event({
        eventCategory: 'Agenda',
        eventAction: 'Nova Task',
        eventValue: this.counterNewTask,
      });

      if (this.newTask && this.newTask.description && this.newTask.due) {
        this.newTask.person = this.person;
        this.newTask.customerId = this.person.customerId;
        await api.postTask(this.newTask);
        await this.$store.dispatch('carregarPerfil', { user: this.$auth.user });
        this.newTask.description = null;
        this.newTask.due = null;
        this.emitSnackBar();
      } else {
        console.log('campos vazios');
      }
    },
    async updateStatus(item) {
      this.counterComplete += 1;

      this.$ga.event({
        eventCategory: 'Agenda',
        eventAction: 'Completar Task',
        eventValue: this.counterComplete,
      });

      if (item.end) {
        item.end = null;
        api.updateTask(item);
        this.emitSnackBar();
      } else {
        item.end = new Date();
        api.updateTask(item);
        this.emitSnackBar();
      }
    },
  },

  filters: {
    truncate(text, length, suffix) {
      if (text.length > length) return text.substring(0, length) + suffix;
      return text;
    },
    formattedDate: (item) => distanceInWordsToNow(item, { addSuffix: true, locale: pt }),
  },
  props: {
    person: Object,
  },
};
</script>

<style scoped>
.v-card {
  box-shadow: none;
  border-radius: 10px;
}

.theme--light.v-sheet {
  border: 1px solid #e0e0e0;
}
</style>

<style>
.fontResize {
  font-size: 11px;
}
.v-label {
  font-size: 11px;
}
.trunk {
  white-space: nowrap;
  overflow: hidden !important;
  text-overflow: ellipsis;
  max-width: 300px;
}
</style>

<style scoped>
.EMDIA {
  border-left: 3px solid #ffc266 !important;
}
.ATRASADO {
  border-left: 3px solid #f7776e !important;
}
.CONCLUIDO {
  border-left: 3px solid #95d097 !important;
}
.create-task-btn {
  border-radius: 39px;
  font-family: 'Nunito Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
}
</style>
